import React from 'react';

import UserIcon from "core/gd-components/icons/user/user";

export default function CustomFieldUsersViewInImport(props) {

    const users = [];
    _.map(props.value, userId=>{
        users.push(gd.session.users.get(userId));
    })

    const optionStyle = {
        minHeight: 24,
        overflow: 'hidden', //required for txt-truncate to work correctly
    };

    return (
        <div className="fl-ac h-24">
            {_.map(users, user=>(
                <div className="ui5-txt-less-important-small fl-ac m-t-4 m-b-4 m-r-15" style={optionStyle}>
                    <UserIcon className="m-r-8" userId={user.id} size="22"/>
                    <div className="ui5-txt-default txt-truncate">{user.name}</div>
                </div>
            ))}
        </div>
    );
}